import React from "react";
import Link from "next/link";
import { excerpt } from "@unisearch/helpers/utils";
import { getAssets } from "@unisearch/helpers";
import moment from "moment";
import styles from "./news_grid_card.module.scss";

/* 
For Custom Classes Props it takes
customClasses:{
  cardClass:customClasses.[your custom class name]
  headClass: customClasses.[your custom class name]
  bodyClass: customClasses.[your custom class name]
  featureImageClass: customClasses.[your custom class name]
  categoryClass: customClasses.[your custom class name]
  categoryItemClass: customClasses.[your custom class name]
  titleClass: customClasses.[your custom class name]
  authorDateClass: customClasses.[your custom class name]
  authorClass: customClasses.[your custom class name]
  dateClass: customClasses.[your custom class name]
  hypenClass: customClasses.[your custom class name]
  descriptionClass: customClasses.[your custom class name]
}

-> for card 'cardClass'
-> for card head 'headClass'
-. for card body 'bodyClass'
-> for featured image 'featureImageClass'
-> for category 'categoryClass'
-> for category item 'categoryItemClass'
-> for title titleClass
-> for author and date wrapper 'authorDateClass'
-> for author 'authorClass'
-> for hypen 'hypenClass'
-> for date 'dateClass'
-> for description 'descriptionClass'
*/

export const NewsGridCard = ({
  data,
  showAuthor = true,
  showImage = true,
  showCategory = false,
  showDescription = false,
  titlePosition = "bottom",
  customStyles,
  customClasses,
  ...props
}) => {
  let detailLink = `/news/${data?.newsFormat}/${data?.slug}`;
  if (data?.newsFormat == "standard") {
    detailLink = `/news/${data?.slug}`;
  }

  return (
    <div
      className={`${styles.news_card} ${
        customClasses?.cardClass ? customClasses?.cardClass : ""
      }`}
    >
      {showImage && (
        <div
          className={`${styles.news_card_head} ${
            customClasses?.headClass ? customClasses?.headClass : ""
          }`}
        >
          <Link legacyBehavior href={detailLink}>
            <a
              className={`${styles.news_card_feature_image_wrapper} ${
                customClasses?.featureImageClass
                  ? customClasses?.featureImageClass
                  : ""
              }`}
            >
              <img
                src={
                  data?.featureImage?.src ||
                  getAssets("assets/images/image_placeholder_big.webp")
                }
                alt={data?.featureImage?.alt || "News Featured Image"}
              />
            </a>
          </Link>
        </div>
      )}

      <div
        className={`${styles.news_card_body} ${
          customClasses?.bodyClass ? customClasses?.bodyClass : ""
        }`}
      >
        {showCategory && (
          <>
            {data && data?.category && data?.category?.length > 0 && (
              <div
                className={`${styles.news_card_categories} ${
                  customClasses?.categoryClass
                    ? customClasses?.categoryClass
                    : ""
                }`}
              >
                {data?.category?.map((cat, i) => {
                  let catLink = `/news/${data?.newsFormat}/category/${cat?.slug}`;
                  if (data?.newsFormat == "standard") {
                    catLink = `/news/category/${cat?.slug}`;
                  }
                  return (
                    <Link legacyBehavior href={catLink}>
                      <a
                        key={`${i}category`}
                        className={`${styles.news_card_category_item} ${
                          customClasses?.categoryItemClass
                            ? customClasses?.categoryItemClass
                            : ""
                        }`}
                      >
                        {cat?.categoryName},{" "}
                      </a>
                    </Link>
                  );
                })}
              </div>
            )}
          </>
        )}
        <Link legacyBehavior href={detailLink}>
          <a>
            <h4
              className={`${styles.news_card_title} ${
                customClasses?.titleClass ? customClasses?.titleClass : ""
              }`}
            >
              {data?.newsTitle || "Title"}
            </h4>
          </a>
        </Link>
        <div
          className={`${styles.news_card_author_date_wrapper} ${
            customClasses?.authorDateClass ? customClasses?.authorDateClass : ""
          }`}
        >
          {showAuthor && (
            <>
              {data?.author && (
                <>
                  <span
                    className={`${styles.news_card_author} ${
                      customClasses?.authorClass
                        ? customClasses?.authorClass
                        : ""
                    }`}
                  >
                    {data?.author?.name}
                  </span>
                  <span
                    className={`${styles.news_card_hypen} ${
                      customClasses?.hypenClass ? customClasses?.hypenClass : ""
                    }`}
                  >
                    {" - "}
                  </span>
                </>
              )}
            </>
          )}

          {data?.publishDate && (
            <span
              className={`${styles.news_card_date} ${
                customClasses?.dateClass ? customClasses?.dateClass : ""
              }`}
            >
              {moment(data?.publishDate).format("MMMM DD, YYYY")}
            </span>
          )}
        </div>

        {showDescription && (
          <div
            className={`${styles.news_card_description} ${
              customClasses?.descriptionClass
                ? customClasses?.descriptionClass
                : ""
            }`}
          >
            {data?.shortDescription
              ? excerpt(data.shortDescription, 200)
              : data?.newsContent
              ? excerpt(data?.newsContent, 200)
              : ""}
          </div>
        )}
      </div>
    </div>
  );
};

export default NewsGridCard;
